// apps/web/src/features/crm/linkedRequestsNav.ts — cross-route navigation
// helper for opening a China request drawer from the CRM lead/deal detail
// (#1598).
//
// WHY: the request drawer is owned by the `/china-rates` workspace
// (`RequestsListPage` opens it whenever `?openId=` is present;
// `useRequestUrlState` falls back the tab to `carriers` WITHOUT requiring
// `?tab=`). The CRM detail surface is a DIFFERENT route, so opening a
// linked request is a cross-route navigation rather than an in-place
// `useRequestUrlState.openRequest`. Centralised so both the lead and deal
// drawers share one tested target string.
import type { NavigateFunction } from 'react-router';

export function openLinkedRequest(navigate: NavigateFunction, requestId: string): void {
  navigate(`/china-rates?openId=${encodeURIComponent(requestId)}`);
}
